var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner_box"},[_c('van-swipe',{staticClass:"banner_box_swipe",attrs:{"show-indicators":false}},[_c('van-swipe-item',[_c('img',{attrs:{"src":require("../../assets/images/home_bg_banner2.png")}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }